import { ModalState } from 'containers/Common/ModalStateFactory';
import { L1Object } from 'core/l1Object/L1Object';
import i18n from 'i18n';
import { DraftSetupStateContent } from './DraftSetupStateContent';
import { DefaultDraftSetupStateContentModel } from './DraftSetupStateContentModel';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';

export class DraftSetupState implements ModalState {
  back?;
  next?;
  close?;
  contentModel: DefaultDraftSetupStateContentModel;
  channelGroupSetting: ChannelGroupSetting;

  constructor(
    protected orderOptions: SelectOptions[],
    protected l1Object: L1Object,
    protected l2ObjectsToCreateDraft: {
      id: number | string;
      isDraft: boolean;
    }[]
  ) {
    this.contentModel = this.getContentModel();
    this.channelGroupSetting = ChannelGroupSetting.fromId(
      l1Object.channelGroupId
    );
  }

  get title() {
    return this.titleFormatter(
      i18n.t('draftCreateModal.titles.duplicate', {
        l2Object: i18n.t('draftCreateModal.titles.target', {
          channel: this.channelGroupSetting.config.name
        }),
        number: this.l2ObjectsToCreateDraft.length
      })
    );
  }

  titleFormatter = (title) => {
    if (i18n.language === 'en' && this.l2ObjectsToCreateDraft.length > 1) {
      return (title = title + 's');
    }
    return title;
  };

  getContentModel = (): DefaultDraftSetupStateContentModel => {
    return new DefaultDraftSetupStateContentModel(
      this.orderOptions,
      this.l1Object.channel
    );
  };

  get content() {
    return DraftSetupStateContent;
  }

  get btnData(): any {
    return {
      primaryButton: this.next && {
        title: i18n.t('draftCreateModal.buttons.goSummary'),
        callback: this.next
      },
      secondaryButton: this.close && {
        title: i18n.t('common.buttons.cancel'),
        callback: this.close
      }
    };
  }

  canGoNext = () => {
    return this.contentModel.canGoNext;
  };
}
